import React, { useState, useEffect } from 'react';
import { MdOutlineCategory } from "react-icons/md";
import { SlLocationPin } from "react-icons/sl";
import { BsBoxSeam } from "react-icons/bs";
import axios from 'axios';
import { USER_URL } from '../../constant/api';
import Loader from '../../components/Loader/Loader';

const InputField = ({ type, placeholder, icon: Icon, className, ...rest }) => (
  <div className={`relative ${className}`}>
    {Icon && <Icon className="absolute top-1/2 right-3 transform -translate-y-1/2 text-gray-400" />}
    <input type={type} placeholder={placeholder} className="p-2 pl-5 border border-gray-300 rounded-md w-full" {...rest} />
  </div>
);

const Button = ({ children, className, ...rest }) => (
  <button className={`bg-green-500 text-white p-2 rounded-md hover:bg-green-600 ease-in-out duration-500 ${className}`} {...rest}>
    {children}
  </button>
);

function AdminDeliveryReport() {
  const [sales, setSales] = useState([]);
  const [filteredSales, setFilteredSales] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [startDate, setStartDate] = useState('');
  const [customerName, setCustomerName] = useState('');
  const [area, setArea] = useState('');

  useEffect(() => {
    const fetchSales = async () => {
      try {
        const response = await USER_URL.get("/orders/admin/sales/");
        if (response.data.Status === "1") {
          setSales(response.data.Data);
          setFilteredSales(response.data.Data);
        }
      } catch (error) {
        console.error("Error fetching sales data:", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchSales();
  }, []);

  const handleSearch = () => {
    let filteredData = [...sales];
    if (startDate) {
      filteredData = filteredData.filter(sale => sale.date === startDate);
    }
    if (customerName) {
      filteredData = filteredData.filter(sale => sale.customer_name.toLowerCase().includes(customerName.toLowerCase()));
    }
    if (area) {
      filteredData = filteredData.filter(sale => sale.place.toLowerCase().includes(area.toLowerCase()));
    }
    setFilteredSales(filteredData);
  };
// order status
const statusMap = {
  0: "Pending",
  1: "Order Confirmed",
  2: "Shipping",
  3: "Delivered",
  4: "Cancelled",
};
  return (
    <div>
      <div className="max-w-md mt-5">
        <h1 className="text-2xl font-medium text-green-600 ">Delivary Report</h1>
        <div className="grid grid-cols-4 gap-4">
          <InputField type="date" className="col-span-2" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
          <InputField type="text" placeholder="Customer Name" icon={MdOutlineCategory} className="col-span-2" value={customerName} onChange={(e) => setCustomerName(e.target.value)} />
          <InputField type="text" placeholder="Area" icon={SlLocationPin} className="col-span-2" value={area} onChange={(e) => setArea(e.target.value)} />
          <Button className="col-span-2" onClick={handleSearch}>Search</Button>
        </div>
      </div>
      <div className="overflow-x-auto mt-5">
        {isLoading ? (
          <Loader />
        ) : filteredSales.length === 0 ? (
          <div className="text-center mt-10">
            <BsBoxSeam className="text-6xl text-gray-400 mx-auto mb-4" />
            <p className="text-lg text-gray-600">No Delivary Report available</p>
          </div>
        ) : (
          <>
            <div className="min-w-[800px] grid grid-cols-[2fr,1fr,1fr,2fr,2fr,1fr,1fr,1fr] font-medium text-brand-button-green-bg">
              <div className="text-center">Customer Name</div>
              <div className="text-center">Order No</div>
              <div className="text-center">Time</div>
              <div className="text-center">Date</div>
              <div className="text-center">Place</div>
              <div className="text-center">Quantity</div>
              <div className="text-center">Status</div>
              <div className="text-center">Total amount</div>
            </div>
            {filteredSales.map((sale) => (
              <div key={sale.order_number} className="grid text-[#2F2E41] min-w-[800px] grid-cols-[2fr,1fr,1fr,2fr,2fr,1fr,1fr,1fr] items-center gap-2 py-2">
                <div className="line-clamp-1 rounded-xl border p-2 text-center">{sale.customer_name}</div>
                <div className="border p-2 rounded-xl text-center line-clamp-1 hover:line-clamp-none">{sale.order_number}</div>
                <div className="border p-2 rounded-xl text-center">{sale.time}</div>
                <div className="border p-2 rounded-xl text-center">{sale.date}</div>
                <div className="border p-2 rounded-xl text-center">{sale.place}</div>
                <div className="border p-2 rounded-xl text-center">{sale.quantity}</div>
                <div className="border p-2 rounded-xl text-center">{statusMap[sale.status]}</div>
                <div className="border p-2 rounded-xl text-center">{sale.total_amount}</div>
              </div>
            ))}
          </>
        )}
      </div>
    </div>
  );
}

export default AdminDeliveryReport;
